
let rowCount = 6;
const ratings = Array(rowCount).fill(0);
const lastRating = Array(rowCount).fill(-1);
let ratingGroups;

export function registerStarListener() {
    const ratingModal = document.getElementById('ratingModal');
    if (!ratingModal) {
        return;
    }

    ratingGroups = ratingModal.querySelectorAll('.stars');

    ratingGroups.forEach((group, groupIndex) => {
        const stars = getStars(group);
        stars.forEach(star => {
            star.addEventListener('mouseover', function() {
                const index = parseInt(this.dataset.index);
                stars.forEach((star, i) => {
                    star.classList.remove('fa-star', 'fa-star-o', 'fa-star-half-o');
                    // Removal of half a star from a whole star
                    if (i === (ratings[groupIndex] - 1) && i === index && ratings[groupIndex] % 1 === 0) {
                        star.style.color = 'gray';
                        star.classList.add('fa-star-half-o');
                    // Removal of half a star from a half star
                    } else if (i === (ratings[groupIndex] - 0.5) && i === index && ratings[groupIndex] % 1 !== 0) {
                        star.style.color = 'gray';
                        star.classList.add('fa-star');
                    // Display star outline, when rating is hovered, but not selected
                    } else if (i <= index && i >= ratings[groupIndex]) {
                        star.style.color = 'var(--secondary-color)';
                        star.classList.add('fa-star-o');
                    // Display whole star outline, when rating is hovered, but not selected for half star
                    } else if (i <= index && ratings[groupIndex] % 1 !== 0 && i == ratings[groupIndex] - 0.5) {
                        star.style.color = 'var(--secondary-color)';
                        star.classList.add('fa-star-o');
                    // Display whole star (selected)
                    } else if (i <= index && i < ratings[groupIndex]) {
                        star.style.color = 'var(--secondary-color)';
                        star.classList.add('fa-star');
                    // Display half star (selected)
                    } else if (i <= index && i >= ratings[groupIndex] && ratings[groupIndex] % 1 !== 0) {
                        star.style.color = 'var(--secondary-color)';
                        star.classList.add('fa-star-half-o');
                    // Display Removal of whole star
                    } else if (i < ratings[groupIndex]) {
                        star.style.color = 'gray';
                        star.classList.add('fa-star');
                    // Display empty star (selected)
                    } else {
                        star.style.color = 'gray';
                        star.classList.add('fa-star-o');
                    }
                });
            });

            star.addEventListener('click', function() {
                let index = parseInt(this.dataset.index);

                // Reduce rating by half a star, if the same full star is clicked twice
                if (lastRating[groupIndex] === index + 1 && ratings[groupIndex] === index + 1) {
                    ratings[groupIndex] = index + 0.5;
                // Reduce rating by half a star, if the same half star is clicked twice
                } else if (lastRating[groupIndex] === index + 0.5 && ratings[groupIndex] === index + 0.5) {
                    ratings[groupIndex] = index;
                // Increase rating by index + 1 for the selected star
                } else {
                    ratings[groupIndex] = index + 1;
                }
                lastRating[groupIndex] = ratings[groupIndex];
                group.querySelector('.rating').value = ratings[groupIndex];
                updateStars(group, ratings[groupIndex]);
            });
        });
        group.addEventListener('mouseout', function() {
            updateStars(group, ratings[groupIndex]);
        });
    });
}

// Function to set initial ratings for a user on page load
export function setInitialRatings(initialRatings) {
    if (!initialRatings) {
        console.error('Initial ratings not found');
        return;
    }

    if (ratingGroups === undefined) {
        console.error('Rating groups not found');
        return;
    }

    ratingGroups.forEach((group, groupIndex) => {
        if (initialRatings[groupIndex] !== undefined) {
            ratings[groupIndex] = initialRatings[groupIndex];
            lastRating[groupIndex] = initialRatings[groupIndex];
            group.querySelector('.rating').value = ratings[groupIndex];
            updateStars(group, ratings[groupIndex]);
        }
    });
}

// Update stars based on rating
function updateStars(group, rating) {
    const stars = getStars(group);
    stars.forEach((star, i) => {
        star.classList.remove('fa-star', 'fa-star-o', 'fa-star-half-o');
        // Display whole star if rating is a whole number
        if (i < Math.floor(rating)) {
            star.style.color = 'var(--secondary-color)';
            star.classList.add('fa-star');
        // Display half star if rating is not a whole number
        } else if (i < rating) {
            star.style.color = 'var(--secondary-color)';
            star.classList.add('fa-star-half-o');
        // Display empty star
        } else {
            star.style.color = 'gray';
            star.classList.add('fa-star-o');
        }
    });
}

function getStars(group) {
    if (!group) return [];
    const stars = group.querySelectorAll('.fa-star, .fa-star-o, .fa-star-half-o');
    return stars;
}

export function getStarsFromNumber(rating, amount = 5) {
    const stars = [];

    // Create full and half stars
    for (let i = 0; i < Math.floor(rating); i++) {
        const star = document.createElement('i');
        star.classList.add('fa', 'fa-star');
        stars.push(star);
    }

    // Check for half star
    if (rating % 1 >= 0.5) {
        const halfStar = document.createElement('i');
        halfStar.classList.add('fa', 'fa-star-half-o', 'text-secondary');
        halfStar.style.color = 'var(--secondary-color)';
        stars.push(halfStar);
    }

    // Add empty stars to complete the 5-star scale
    for (let i = stars.length; i < amount; i++) {
        const emptyStar = document.createElement('i');
        emptyStar.classList.add('fa', 'fa-star-o');
        stars.push(emptyStar);
    }

    return stars;
}

export function getAsElement(rating, amount = 5) {
    const stars = getStarsFromNumber(rating, amount);
    const star = document.createElement('div');

    stars.forEach(starElement => {
        star.appendChild(starElement);
    });


    return star;
}

export function getAsString(rating, amount = 5) {
    const stars = getStarsFromNumber(rating, amount);
    let starString = '';

    stars.forEach(starElement => {
        starString += starElement.outerHTML;
    });

    return starString;
}